import React, { useEffect, useState } from "react";

import { ResultBar } from "@/components/ResultBar/ResultBar";

import { OptionEnum, OptionModeEnum, OptionTypeEnum } from "../index";
import { Flexbox, Text, Wrapper } from "./styles";

export type TextOptionProps = {
  interactionId: string;
  slideId: string;
  optionId: string;
  mode: OptionModeEnum;
  type: OptionTypeEnum;
  isClickable: boolean;
  isSecret?: boolean;
  answer?: OptionEnum;
  percent?: number;
  onClick: Function;
  children?: React.ReactNode;
};
export type TextOptionState = {
  wasClicked: boolean;
  answerState: OptionEnum | undefined;
};

export const TextOption: React.FC<TextOptionProps> = (
  props: TextOptionProps
): JSX.Element => {
  const {
    mode,
    type,
    percent,
    answer,
    isSecret,
    isClickable,
    interactionId,
    slideId,
    optionId,
    onClick,
  } = props;
  const [localAnswer, setLocalAnswer] = useState<OptionEnum | undefined>(
    answer
  );
  const [wasClicked, setWasClicked] = useState<boolean>(false);

  useEffect(() => {
    // User clicked the wrong answer. Resolve correct answers.
    if (
      type === OptionTypeEnum.quiz &&
      answer === OptionEnum.correct &&
      !wasClicked
    ) {
      setTimeout(() => setLocalAnswer(answer), 800);
    } else {
      setLocalAnswer(answer);
    }
  }, [answer]);

  const handleClick = (): void => {
    if (!isClickable) {
      return;
    }

    if (type === OptionTypeEnum.quiz) {
      onClick({
        quizId: interactionId,
        slideId,
        optionId,
      });
    } else {
      onClick({ interactionId, slideId, optionId });
    }

    setWasClicked(true);
  };

  return (
    <Wrapper data-qa="answer:btn" onClick={handleClick} clickable={isClickable}>
      <Flexbox answer={localAnswer} mode={mode} clickable={isClickable}>
        <Text type={type} answer={localAnswer} mode={mode}>
          {props.children}
        </Text>
      </Flexbox>
      <ResultBar
        mode={mode}
        type={type}
        percent={percent}
        answer={localAnswer}
        isSecret={isSecret}
      />
    </Wrapper>
  );
};
